import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
    selector: 'app-alert-confirm',
    templateUrl: './alert-confirm.component.html',
    styleUrls: ['./alert-confirm.component.scss']
})
export class AlertConfirmComponent implements OnInit {

    mode: string;

    constructor(
        public dialogRef: MatDialogRef<AlertConfirmComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any) {
    }

    ngOnInit(): void {
        this.mode = this.data.mode;
    }

    onNoClick(): void {
        this.dialogRef.close(false);
    }
}
